import React, { useContext, useMemo } from 'react';
import { defineMessages } from 'react-intl';
import { bool } from 'prop-types';

import LearnMore from '../LearnMore';
import SelectDropdown from '../../../forms/SelectDropdown';
import { PrintContext } from '../../printContext';
import { SCALES } from '../../constants';
import CustomProvider from 'components/CustomProvider';
import useFormatMessage from 'hooks/useFormatMessage';

const SCALE_STRINGS = defineMessages({
  SCALE: { defaultMessage: 'Scale' },
  CONTENT: {
    defaultMessage:
      "The scale of a map is the ratio of a distance on the map to the corresponding distance on the ground. This simple concept is complicated by the curvature of the Earth's surface, which forces scale to vary across a map. Because of this variation, the concept of scale becomes meaningful in two distinct ways."
  }
});

const Scale = ({ isMobileWidth }) => {
  const {
    formattedDefaultMessages: { SCALE, CONTENT }
  } = useFormatMessage(SCALE_STRINGS);
  const { scale, setScale } = useContext(PrintContext);

  const options = useMemo(() => Object.entries(SCALES).map(([value, label]) => ({ value, label })), []);

  const defaultItem = { value: scale };

  return (
    <CustomProvider>
      <div className="scaleContainer">
        <SelectDropdown options={options} className="scaleSelect" defaultItem={defaultItem} handleChange={e => setScale(parseInt(e.target.value))} />
        <LearnMore title={SCALE} content={CONTENT} isMobileWidth={isMobileWidth} scale />
      </div>
    </CustomProvider>
  );
};

Scale.propTypes = {
  isMobileWidth: bool
};

Scale.defaultProps = {
  isMobileWidth: false
};

export { Scale };
